import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=72addf51&scoped=true&"
import script from "./wizard.vue?vue&type=script&lang=js&"
export * from "./wizard.vue?vue&type=script&lang=js&"
import style0 from "./wizard.vue?vue&type=style&index=0&id=72addf51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72addf51",
  null
  
)

export default component.exports